import React from 'react';

import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  margin-top: -5px;
`;

export const BarText = styled.div`
  font-size: 14px;
  color: var(--colorBlueGray100);
  margin-right: 32px;
`;

export const BarWrapper = styled.div`
  display: flex;
  margin-top: -5px;
`;

export const Step = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  cursor: pointer;
`;

export const StepCircle = styled.div<{ content: string; status: string }>`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: ${({ status }) =>
    status == 'PASSED' ? 'var(--colorUIGreen)' : 'var(--colorBlueGray200)'};
  position: relative;
  &:after {
    content: '${({ content }) => content}';
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    line-height: 12px;
    color: var(--colorBlueGray100);
  }
`;

export const Line = styled.div<{ status: string }>`
  width: 48px;
  height: 1px;
  margin: 10px 8px 0;
  background-color: ${({ status }) =>
    status === 'PASSED' ? 'var(--colorUIGreen)' : 'var(--colorBlueGray100)'};
`;
